import { iconPaths } from '../components/Icon';

export const icon: Record<string, keyof typeof iconPaths> = {
	IconHeart: 'IconHeartGreen',
	IconHeartFilled: 'IconHeartFilledGreen',
};
